export const helpContactNumber = import.meta.env.VITE_HELP_PHONENUMBER;
